import React, { Component } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { Space, Radio, message, Spin } from "antd";
import Bridge from "../../../utils/Bridge";
import { logEvent } from "../../../utils/analytics";

export default class Roads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      field_data: [],

      nod_yes_or_no: '',
      ride_in_a_car: '',
      eat_soup: '',
      drink_milkshake_or_smoothie: '',
      sit_on_a_toilet: '',
      swallow_pills: '',
      blow_out_a_candle: '',
      eat_dry_food_e_g_cornbread_e_g_cornbread: '',
      speak_on_the_phone: '',
      drink_out_of_a_glass: '',
      eat_a_large_meal: '',
      sign_name_on_paper: '',
      get_into_bed: '',
      roll_over_in_bed: '',
      take_a_shower: '',
      use_a_knife_and_fork: '',
      walk_around_your_home: '',
      move_a_chair: '',
      speak_in_a_loud_room: '',
      speak_for_hours: '',
      clip_nails: '',
      walk_up_1_flight_of_stairs: '',
      walk_up_a_hill: '',
      climb_a_stepstool: '',
      get_up_from_the_floor: '',
      carry_an_object_downstairs: '',
      stand_for_hours: '',
      get_heavy_objects_off_a_high_shelf: ''
    };
  }
  componentDidMount() {
    this.get_alsfrs_details()
  }
  get_alsfrs_details = () => {
    this.setState({ loading: true })
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id") + '&type=form';
    Bridge.participants.speech.alsfrs
      .list(params)
      .then((response) => {
        if (response.status == "1") {

          if (response.data.is_rasch_present == true) {
            window.location.assign('/update-alsfrs-and-roads')
            return
          }
          let list = response.data.rasch_questions
          const uniquefields = [...new Map(list.map(item => [item.field, item])).values()];
          const uniqueNames2 = [...new Map(list.map(item => [item.field, item.field])).values()];

          let rasch_questions_arr = [];
          for (let item of uniquefields) {
            let arr = list.filter(i => i.field == item.field);
            let options = arr.map(i => ({
              label: i.description,
              value: i.values,
            }))
            rasch_questions_arr.push({
              field: item.field,
              options: options,
              field_label: item.field_label,
              // item: item,
              view_name: item.view_name,
              state_name: "",
              value: ""
            })
          }
          let new_arr = []
          let cutting_food_a_questions = []
          let cutting_food_b_questions = []
          for (let item of rasch_questions_arr) {
            if (item.field == 'ROADS_1') {
              item.state_name = 'nod_yes_or_no'
              // this.setState({nod_yes_or_no: item.value})
            }
            if (item.field == 'ROADS_2') {
              item.state_name = 'ride_in_a_car'
              // this.setState({ride_in_a_car: item.value})
            }
            if (item.field == 'ROADS_3') {
              item.state_name = 'eat_soup'
              // this.setState({eat_soup: item.value})
            }
            if (item.field == 'ROADS_4') {
              item.state_name = 'drink_milkshake_or_smoothie'
              // this.setState({drink_milkshake_or_smoothie: item.value})
            }
            if (item.field == 'ROADS_5') {
              item.state_name = 'sit_on_a_toilet'
              // this.setState({sit_on_a_toilet: item.value})
            }
            if (item.field == 'ROADS_6') {
              item.state_name = 'swallow_pills'
              // this.setState({swallow_pills: item.value})
            }
            if (item.field == 'ROADS_7') {
              item.state_name = 'blow_out_a_candle'
              // this.setState({blow_out_candle: item.value})
            }
            if (item.field == 'ROADS_8') {
              item.state_name = 'eat_dry_food_e_g_cornbread'
              // this.setState({eat_dry_food_e_g_cornbread: item.value})
            }
            if (item.field == 'ROADS_9') {
              item.state_name = 'speak_on_the_phone'
              // this.setState({speak_on_the_phone: item.value})
            }
            if (item.field == 'ROADS_10') {
              item.state_name = 'drink_out_of_a_glass'
              // this.setState({drink_out_of_a_glass: item.value})
            }
            if (item.field == 'ROADS_11') {
              item.state_name = 'eat_a_large_meal'
              // this.setState({eat_a_large_meal: item.value})
            }
            if (item.field == 'ROADS_12') {
              item.state_name = 'sign_name_on_paper'
              // this.setState({sign_name_on_paper: item.value})
            }
            if (item.field == 'ROADS_13') {
              item.state_name = 'get_into_bed'
              // this.setState({get_into_bed: item.value})
            }
            if (item.field == 'ROADS_14') {
              item.state_name = 'roll_over_in_bed'
              // this.setState({roll_over_in_bed: item.value})
            }
            if (item.field == 'ROADS_15') {
              item.state_name = 'take_a_shower'
              // this.setState({take_a_shower: item.value})
            }
            if (item.field == 'ROADS_16') {
              item.state_name = 'use_a_knife_and_fork'
              // this.setState({use_a_knife_and_fork: item.value})
            }
            if (item.field == 'ROADS_17') {
              item.state_name = 'walk_around_your_home'
              // this.setState({walk_around_your_home: item.value})
            }
            if (item.field == 'ROADS_18') {
              item.state_name = 'move_a_chair'
              // this.setState({move_a_chair: item.value})
            }
            if (item.field == 'ROADS_19') {
              item.state_name = 'speak_in_a_loud_room'
              // this.setState({speak_in_a_loud_room: item.value})
            }
            if (item.field == 'ROADS_20') {
              item.state_name = 'speak_for_hours'
              // this.setState({speak_for_hours: item.value})
            }
            if (item.field == 'ROADS_21') {
              item.state_name = 'clip_nails'
              // this.setState({clip_nails: item.value})
            }
            if (item.field == 'ROADS_22') {
              item.state_name = 'walk_up_1_flight_of_stairs'
              // this.setState({walk_up_1_flight_of_stairs: item.value})
            }
            if (item.field == 'ROADS_23') {
              item.state_name = 'walk_up_a_hill'
              // this.setState({walk_up_a_hill: item.value})
            }
            if (item.field == 'ROADS_24') {
              item.state_name = 'climb_a_stepstool'
              // this.setState({climb_a_stepstool: item.value})
            }
            if (item.field == 'ROADS_25') {
              item.state_name = 'get_up_from_the_floor'
              // this.setState({get_up_from_the_floor: item.value})
            }
            if (item.field == 'ROADS_26') {
              item.state_name = 'carry_an_object_downstairs'
              // this.setState({carry_an_object_downstairs: item.value})
            }
            if (item.field == 'ROADS_27') {
              item.state_name = 'stand_for_hours'
              // this.setState({stand_for_hours: item.value})
            }
            if (item.field == 'ROADS_28') {
              item.state_name = 'get_heavy_objects_off_a_high_shelf'
              // this.setState({get_heavy_objects_off_a_high_shelf: item.value})
            }
            new_arr.push(item)
          }
          this.setState({
            field_data: new_arr,
            loading: false
          })
        } else {
          this.setState({ loading: false })
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  }
  save_details = () => {
    if (!this.state.nod_yes_or_no) {
      message.warning("Please select Nod yes or no value");
      return;
    }
    if (!this.state.ride_in_a_car) {
      message.warning("Please select Ride in a car value");
      return;
    }
    if (!this.state.eat_soup) {
      message.warning("Please select Eat soup value");
      return;
    }
    if (!this.state.drink_milkshake_or_smoothie) {
      message.warning("Please select Drink milkshake or smoothie value");
      return;
    }
    if (!this.state.sit_on_a_toilet) {
      message.warning("Please select Sit on a toilet value");
      return;
    }
    if (!this.state.swallow_pills) {
      message.warning("Please select Swallow pills value");
      return;
    }
    if (!this.state.blow_out_a_candle) {
      message.warning("Please select Blow out a candle value");
      return;
    }
    if (!this.state.eat_dry_food_e_g_cornbread) {
      message.warning("Please select Eat dry food e.g. cornbread value");
      return;
    }
    if (!this.state.speak_on_the_phone) {
      message.warning("Please select Speak on the phone value");
      return;
    }
    if (!this.state.drink_out_of_a_glass) {
      message.warning("Please select Drink out of a glass value");
      return;
    }
    if (!this.state.eat_a_large_meal) {
      message.warning("Please select Eat a large meal value");
      return;
    }
    if (!this.state.sign_name_on_paper) {
      message.warning("Please select Sign name on paper value");
      return;
    }
    if (!this.state.get_into_bed) {
      message.warning("Please select Get into bed value");
      return;
    }
    if (!this.state.roll_over_in_bed) {
      message.warning("Please select Roll over in bed value");
      return;
    }
    if (!this.state.take_a_shower) {
      message.warning("Please select Take a shower value");
      return;
    }
    if (!this.state.use_a_knife_and_fork) {
      message.warning("Please select Use a knife and fork value");
      return;
    }
    if (!this.state.walk_around_your_home) {
      message.warning("Please select Walk around your home value");
      return;
    }
    if (!this.state.move_a_chair) {
      message.warning("Please select Move a chair value");
      return;
    }
    if (!this.state.speak_in_a_loud_room) {
      message.warning("Please select Speak in a loud room value");
      return;
    }
    if (!this.state.speak_for_hours) {
      message.warning("Please select Speak for hours value");
      return;
    }
    if (!this.state.clip_nails) {
      message.warning("Please select Clip nails value");
      return;
    }
    if (!this.state.walk_up_1_flight_of_stairs) {
      message.warning("Please select Walk up 1 flight of stairs value");
      return;
    }
    if (!this.state.walk_up_a_hill) {
      message.warning("Please select Walk up a hill value");
      return;
    }
    if (!this.state.climb_a_stepstool) {
      message.warning("Please select Climb a stepstool value");
      return;
    }
    if (!this.state.get_up_from_the_floor) {
      message.warning("Please select Get up from the floor value");
      return;
    }
    if (!this.state.carry_an_object_downstairs) {
      message.warning("Please select Carry an object downstairs value");
      return;
    }
    if (!this.state.stand_for_hours) {
      message.warning("Please select Stand for hours value");
      return;
    }
    if (!this.state.get_heavy_objects_off_a_high_shelf) {
      message.warning("Please select Get heavy objects off a high shelf value");
      return;
    }

    let field_data = this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];

    let questions = []
    for (let item of uniqueNames) {
      if (item.field == 'ROADS_1') {
        let obj = {
          value: this.state.nod_yes_or_no,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_2') {
        let obj = {
          value: this.state.ride_in_a_car,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_3') {
        let obj = {
          value: this.state.eat_soup,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_4') {
        let obj = {
          value: this.state.drink_milkshake_or_smoothie,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_5') {
        let obj = {
          value: this.state.sit_on_a_toilet,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_6') {
        let obj = {
          value: this.state.swallow_pills,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_7') {
        let obj = {
          value: this.state.blow_out_a_candle,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_8') {
        let obj = {
          value: this.state.eat_dry_food_e_g_cornbread,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_9') {
        let obj = {
          value: this.state.speak_on_the_phone,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_10') {
        let obj = {
          value: this.state.drink_out_of_a_glass,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_11') {
        let obj = {
          value: this.state.eat_a_large_meal,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_12') {
        let obj = {
          value: this.state.sign_name_on_paper,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_13') {
        let obj = {
          value: this.state.get_into_bed,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_14') {
        let obj = {
          value: this.state.roll_over_in_bed,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_15') {
        let obj = {
          value: this.state.take_a_shower,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_16') {
        let obj = {
          value: this.state.use_a_knife_and_fork,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_17') {
        let obj = {
          value: this.state.walk_around_your_home,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_18') {
        let obj = {
          value: this.state.move_a_chair,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_19') {
        let obj = {
          value: this.state.speak_in_a_loud_room,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_20') {
        let obj = {
          value: this.state.speak_for_hours,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_21') {
        let obj = {
          value: this.state.clip_nails,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_22') {
        let obj = {
          value: this.state.walk_up_1_flight_of_stairs,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_23') {
        let obj = {
          value: this.state.walk_up_a_hill,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_24') {
        let obj = {
          value: this.state.climb_a_stepstool,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_25') {
        let obj = {
          value: this.state.get_up_from_the_floor,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_26') {
        let obj = {
          value: this.state.carry_an_object_downstairs,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_27') {
        let obj = {
          value: this.state.stand_for_hours,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
      if (item.field == 'ROADS_28') {
        let obj = {
          value: this.state.get_heavy_objects_off_a_high_shelf,
          view_name: item.view_name,
          form: "Rasch Overall ALS Disability Scale (ROADS)",
          field: item.field
        }
        questions.push(obj)
      }
    }
    let params = {
      data: JSON.stringify(questions),
      participants_accounts_id: localStorage.getItem("ap_participants_accounts_id")
    };
    this.setState({ loading: true });
    Bridge.participants.speech.alsfrs
      .save_alsfrs(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          logEvent("form_submitted", { form_name: "roads" });
          message.success('Roads data is saved successfully.');
          this.setState(
            {
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.assign("/update-alsfrs-and-roads");
              }, 3000);
            }
          );
        } else {
          message.error(response.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  }
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a href="/dashboard" className="back-arrow">
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    Dashboard
                  </a>
                  <div>
                    <div className="header">
                      <h3 className="text-uppercase">Rasch Overall ALS Disability Scale (ROADS)</h3>
                      <div className="white-block"></div>
                    </div>
                    <div className="form-fields">
                      <Spin spinning={this.state.loading}>
                        <div>
                          {this.state.field_data.map((item, index) => {
                            return (
                              <div className="form-group" key={index}>
                                <label className="input-heading">
                                  {item.field_label}{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <br />
                                <Radio.Group
                                  onChange={(e) =>
                                    this.setState({
                                      [item.state_name]: e.target.value,
                                    })
                                  }
                                  value={this.state[item.state_name]}
                                  direction={'horizontal'}
                                >
                                  <Space direction="horizontal">
                                    {item.options.map((single, i) => {
                                      return (<Radio value={single.value}>{single.label}</Radio>)
                                    })}
                                  </Space>
                                </Radio.Group>
                              </div>
                            )
                          })}
                          <button
                            className="submit-button"
                            style={{ padding: "9px 15px 10px 20px" }}
                            onClick={() => this.save_details()}
                          >
                            <box-icon
                              name="save"
                              type="solid"
                              color="#fff"
                              size={'17px'}
                              style={{ position: 'relative', top: -1, left: -11 }}
                            ></box-icon>
                            Save{" "}
                          </button>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
